export default __webpack_public_path__ + "img/ezDDkrPs.cdb9856f.svg";